import { useApi } from '../api/useApi';
import { UserLifecycleActionPage } from '../features/users/UserLifecycleActionPage';

export function DeleteUserPage() {
  const api = useApi();
  return (
    <UserLifecycleActionPage
      title="Benutzer löschen"
      description="Benutzer löschen — wiederherstellbar für 30 Tage (Papierkorb)."
      pageKey="users.delete"
      confirmLabel="Endgültig löschen"
      danger
      warning="Achtung: Der Benutzer wird gelöscht. Er verbleibt 30 Tage im Papierkorb und kann in dieser Zeit wiederhergestellt werden. Diese Aktion ist standardmäßig freigabepflichtig (4-Augen)."
      action={(id, ticket) => api.deleteUser(id, ticket)}
    />
  );
}
